import React from "react";
import { FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import { AntInput } from "../../../CommonElements/AntInput";
import {
  validateArabicAndNumbersOnly,
  validateArabicOnly,
  validateEnglishAndNumbersOnly,
  validateEnglishOnly,
} from "../../../Pages/ProfileForm/validationUtils";
import { useTranslation } from "react-i18next";

export const CityForm = (props) => {
  const { control, errors } = props;
  const { t } = useTranslation();

  return (
    <>
      <FormGroup className="mb-3">
        <Controller
          control={control}
          name="name_ar"
          rules={{
            required: t("CITY_NAME_ARABIC_REQUIRED"),
            validate: (value) => validateArabicAndNumbersOnly(value, t),
          }}
          render={({ field }) => (
            <>
              <Label for="name_ar">{t("CITY_NAME_ARABIC")}</Label>
              <AntInput
                type="text"
                id="name_ar"
                name="name_ar"
                {...field}
                placeholder={t("CITY_NAME_ARABIC_PLACEHOLDER")}
              />
              {errors.name_ar && (
                <div className="text-danger">{errors.name_ar.message}</div>
              )}
            </>
          )}
        />
      </FormGroup>
      <FormGroup className="mb-3">
        <Controller
          control={control}
          name="name_en"
          rules={{
            required: t("CITY_NAME_ENGLISH_REQUIRED"),
            validate: (value) => validateEnglishAndNumbersOnly(value, t),
          }}
          render={({ field }) => (
            <>
              <Label for="name_en">{t("CITY_NAME_ENGLISH")}</Label>
              <AntInput
                type="text"
                id="name_en"
                name="name_en"
                {...field}
                placeholder={t("CITY_NAME_ENGLISH_PLACEHOLDER")}
              />
              {errors.name_en && (
                <div className="text-danger">{errors.name_en.message}</div>
              )}
            </>
          )}
        />
      </FormGroup>
    </>
  );
};
